import React from "react";
import { IoMdClose } from "react-icons/io";

const PersonalProductCard = ({ card }) => (
  <div className="personal-product-card">
    <img
      src={card.image}
      alt={`${card.heading} product`}
      className="product-image"
    />
    <div className="product-details">
      <div className="product-header">
        <h4>{card.heading}</h4> 
        <IoMdClose className="close-icon" />
      </div>
      <p>
        {card.color} | {card.size}
      </p>
      <p>{card.price}</p>
      <button className={`status-button ${card.statusClass}`}>
        {card.status}
      </button>
    </div>
  </div>
);

export default PersonalProductCard;
